import bannerSports from "@/assets/Assinar.png";
import Link from "next/link";

export default function AssignatureSportsScreen() {
  return (
    <div className="flex flex-col items-center">
      <div className="flex w-[80%] items-start justify-start p-0 mb-40">
        <div
          className="w-full h-[50vh] flex flex-col items-center justify-end text-white p-8 rounded-lg shadow-lg mt-10 bg-cover bg-center"
          style={{ backgroundImage: `url(${bannerSports.src})` }}
        >
          <Link href={"https://alertai.com.br/app/authentication/signUp"}>
            <button className="bg-white text-orange-500 font-bold py-2 px-4 rounded-lg transform transition-transform duration-300 hover:scale-105">
              Assinar Agora
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}
